import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import columnWidthsTofr from './helpers/columnWidthsTofr'

const Container = styled.div`
  display: grid;
  grid-template-columns: ${props => columnWidthsTofr(props.columnWidths)};
  padding: 5px 10px;
  &:nth-of-type(even) {
    background: white;
  }
  &:nth-of-type(odd) {
    background: #e8e8e8;
  }
`
const Cell = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`
const GenieRow = ({ data, columnWidths }) => {
  return (
    <Container columnWidths={columnWidths}>
      {data.map((d, i) => <Cell key={i}>{d}</Cell>)}
    </Container>
  )
}

GenieRow.propTypes = {
  columnWidths: PropTypes.arrayOf(PropTypes.number),
  data: PropTypes.arrayOf(PropTypes.any)
}

export default GenieRow
